import { QUERY_GET_FACTORY_ADVANCE_OPTIONS} from '../../fetch/constantQueries'
import { baseThunk } from '../../fetch/basicThunk';

export const getFactoryAdvanceOptions = baseThunk(`factoryAdvanceOptions/getOptions`, QUERY_GET_FACTORY_ADVANCE_OPTIONS, "GET")
